const NS = 'WoolLabPersistentSwatchDrawer';
const CLS = 'woolLabPersistentSwatchDrawer';

import Handlebars from 'handlebars';
import {WoolLabSwatchDetailModalBlock} from './woolLabSwatchDetailModalBlock';


export class WoolLabPersistentSwatchDrawer {

	constructor(el) {
		this.$el = $(el);

		this.addToMoodboardApi = this.$el.data('addToMoodboardApi');
		this.getSwatchDetailApi = this.$el.data('swatchDetailApi');
		this.getSupplierDetailApi = this.$el.data('getSupplierDetailApi');
		this.isInMySwatchesApi = this.$el.data('isInMySwatchesApi');
		this.getMySwatchesApi = this.$el.data('mySwatchesApi');
		this.addToMySwatches = this.$el.data('addToMySwatchesApi');
		this.useDetailsModal = this.$el.data('useDetailsModal');
		this.getMoodboardsApi = this.$el.data('getMoodboardsApi');
		this.createMoodboardApi = this.$el.data('createMoodboardApi');
		this.isstudentApi = this.$el.data('isstudent');

		this.$addToMoodboardBtn = this.$el.find(`.${CLS}-addToMoodboardBtn`);
		this.$openBtn = this.$el.find(`.${CLS}-openBtn`);
		this.$panel = this.$el.find(`.${CLS}-panel`);
		this.$closeBtn = this.$el.find(`.${CLS}-closeBtn`);
		this.$background = this.$el.find(`.${CLS}-background`);

		this.$fabricSwatches = this.$el.find(`.${CLS}-swatches`);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.fabricSwatches = [];

		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.loadingSwatches = false;

		this.$swatchBlock = [];

		this.selectedSwatchIds = [];
		this.$swatchSelectPanel = this.$el.find(`.${CLS}-swatchSelect-panel`);

		this.handleButtons();
	}

	getSwatches() {

		if (!this.loadingSwatches) {

			this.selectedSwatchIds = [];
			this.loadingSwatches = true;
			let url = this.getMySwatchesApi;
			this.$loadingScreen.addClass('active');

			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {

					this.$searchResultsEmpty.hide();

					this.$fabricSwatches.empty();

					let fabricSwatchMarkup = (swatch) => {
						return `
							<div class="${CLS}-swatch" data-id="${swatch.id}" data-img-src="${swatch.fullImageSrc}" data-isstudent="${this.isstudentApi}">
								<div class="${CLS}-swatch-tick"></div>
								<img class="${CLS}-swatch-image" src="${swatch.imageSrc}">
							</div>`;
					};

					if (data.length > 0) {
						data.forEach((item) => {
							item.getSwatchDetailApi = this.getSwatchDetailApi;
							item.getSupplierDetailApi = this.getSupplierDetailApi;
							item.isInMySwatchesApi = this.isInMySwatchesApi;
							this.$fabricSwatches.append(fabricSwatchMarkup(item));
						});

						this.$swatchBlock = this.$el.find(`.${CLS}-swatch`);
						this.handleSwatchBtn();

					} else {
						this.$searchResultsEmpty.show();
					}

					this.$loadingScreen.removeClass('active');
				},
				error: (error) => {
				},
				complete: () => {
					this.loadingSwatches = false;
				},
			});
		}
	}


	handleButtons() {
		this.$openBtn.on('click', () => {
			this.getSwatches();
			this.$el.addClass('active');
		});
		this.$closeBtn.on('click', () => {
			this.$el.removeClass('active');
		});
		this.$background.on('click', () => {
			this.$el.removeClass('active');
		});

		this.$addToMoodboardBtn.on('click', () => {
			this.$el.removeClass('active');
		});
	}


	handleSwatchBtn() {
		this.$swatchBlock.on('click', (e) => {
			let $swatch = $(e.currentTarget);

			if (this.useDetailsModal) {
				this.displaySwatchDetailModal($swatch.attr('data-id'));
			} else {
				if ($swatch.hasClass('selected')) {
						$swatch.removeClass('selected');

						let filteredItems = this.selectedSwatchIds.filter((item) => item !== $swatch.attr('data-id'));
						this.selectedSwatchIds = filteredItems;
					} else {
							$swatch.addClass('selected');
							this.selectedSwatchIds.push($swatch.attr('data-id'));
					}
				this.updateSelectedSwatchCount();
			}
		});
	}


    updateSelectedSwatchCount() {
        if (this.selectedSwatchIds.length > 0 ) {
			this.$swatchSelectPanel.addClass('active');
        } else {
			this.$swatchSelectPanel.removeClass('active');
        }
    }


	displaySwatchDetailModal(id) {
		let modalData = {};
		modalData.id = id;
		modalData.getSwatchDetailApi = this.getSwatchDetailApi;
		modalData.getSupplierDetailApi = this.getSupplierDetailApi;
		modalData.isInMySwatchesApi = this.isInMySwatchesApi;
		modalData.addToMoodboardApi = this.addToMoodboardApi;
		modalData.addToMySwatches = this.addToMySwatches;
		modalData.addToMoodboardApi = this.addToMoodboardApi;
		modalData.getMoodboardsApi = this.getMoodboardsApi;
		modalData.createMoodboardApi = this.createMoodboardApi;
		modalData.isStudent = this.isstudentApi;


		$(document.body).append(this.getModalTemplate()(modalData));
		let $modal = $(`#woolLabSwatchDetailModalBlock--${id}`);
		new WoolLabSwatchDetailModalBlock($modal[0], modalData);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
		});
	}

	getModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabSwatchDetailModalBlock.hbs');

		Handlebars.registerPartial('woolLabSwatchDetailModalBlock', modalWidget);

		let template = `
			{{> woolLabSwatchDetailModalBlock
				wg="woolLabSwatchDetailModalBlock"
				ns="WoolLabSwatchDetailModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}
}
